<template>
    <q-btn
            color="warning"
            label="Escalate"
            @click="openModal"
    />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Post } from '@/type';
import openModal from '@/components/modal';
import EscalateModal from '@/social/post/escalate/EscalateModal.vue';

export default defineComponent({
  emits: ['escalated'],
  props: {
    post: {
      type: Object as () => Post,
      required: true,
    },
  },
  methods: {
    openModal() {
      const props = { post: this.post };
      openModal(EscalateModal, props).onOk((post: Post) => {
        this.$emit('escalated', post);
      });
    },
  },
});
</script>
